import PropTypes from 'prop-types';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { ROUTES_PATH } from 'config/constants';

import { useAuth } from '../../providers/AuthProvider';

const PrivateRoute = ({ children, routeRedirection, ...props }) => {
  const { apiToken } = useAuth();
  const location = useLocation();
  const currentRoute = location.pathname;
  const id = currentRoute.split('/').pop();

  return (
    <Route {...props}>
      {apiToken || currentRoute === ROUTES_PATH.ACCEPT_INVIT.replace(':id', id) && id ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: routeRedirection,
            state: { referrer: location.pathname },
          }}
        />
      )}
    </Route>
  );
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  routeRedirection: PropTypes.string,
};

export default PrivateRoute;